import { HubConnection } from '@microsoft/signalr';

// Change the currently selected mining zone
export const changeMiningZone = async (connection: HubConnection, playerId: string, zoneId: string): Promise<any> => {
  return await connection.invoke('ChangeMiningZone', playerId, zoneId);
};

